import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  copyData: [],
  secondCopyData: null,
  error: false,
  errMessage: "",
  isSorted: false,
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
      // state.error = false;
    },
    setCopyData: (state, action) => {
      state.copyData = action.payload;
      // state.error = false;
    },
    setSecondCopyData: (state, action) => {
      state.secondCopyData = action.payload;
      // state.error = false;
    },
    setErrMessage: (state, action) => {
      state.errMessage = action.payload;
    },
    setError: (state, action) => {
      // state.data = [];
      state.error = action.payload === "false" ? false : true;
    },
    setSortStatus: (state, action) => {
      state.isSorted = action.payload;
    },
    setReset: (state) => {
      state.data = [];
      state.error = false;
    },
  },
});

export const {
  setData,
  setCopyData,
  setSecondCopyData,
  setError,
  setReset,
  setSortStatus,
  setErrMessage,
  setIsLoaded,
} = dataSlice.actions;

export const updateData = (filteredData) => (dispatch) => {
  dispatch(setData(filteredData));
};

export default dataSlice.reducer;
